// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2_6Jv","modalFooterButton":"ModalNotes_modalFooterButton__3E6s9"};